import Enumerable from "linq";
import { PaperSizeKinds } from ".";
import { ISize } from "../../../base/domain/drawing";
import { IPaper } from "../../../base/domain/system/document";

export class PaperUtility {
  private static readonly dpi: number = 96;
  private static readonly inch: number = 25.4;
  private static readonly ppi: number = 72;

  private static toPaper(name: string, width: number, height: number): IPaper {
    return {
      name: name,
      size: {
        width: PaperUtility.mmToPixel(width),
        height: PaperUtility.mmToPixel(height),
      },
    };
  }

  private static mmToPixel(mm: number): number {
    return mm * PaperUtility.dpi / PaperUtility.inch;
  }

  static pointToPixel(pt: number): number {
    return pt / PaperUtility.ppi * PaperUtility.dpi;
  }

  static pixelToPoint(px: number): number {
    return px * PaperUtility.ppi / PaperUtility.dpi;
  }

  static sizeToKind(size: ISize): PaperSizeKinds {
    const width = Math.floor(size.width);
    const height = Math.floor(size.height);
    return Enumerable.from(PaperUtility.IPapers)
      .indexOf(p =>
        ((Math.floor(p.size.width) === width) && (Math.floor(p.size.height) === height)) ||
        ((Math.floor(p.size.width) === height) && (Math.floor(p.size.height) === width)));
  }

  // PaperSizeKindsの定義が変わったら修正する必要あり
  static get IPapers(): IPaper[] {
    return [
      PaperUtility.A0,
      PaperUtility.A1,
      PaperUtility.A2,
      PaperUtility.A3,
      PaperUtility.A4,
      PaperUtility.A5,
      PaperUtility.A6,
      PaperUtility.A7,
      PaperUtility.A8,
      PaperUtility.A9,
      PaperUtility.A10,
      PaperUtility.A11,
      PaperUtility.A12,
      PaperUtility.B0,
      PaperUtility.B1,
      PaperUtility.B2,
      PaperUtility.B3,
      PaperUtility.B4,
      PaperUtility.B5,
      PaperUtility.B6,
      PaperUtility.B7,
      PaperUtility.B8,
      PaperUtility.B9,
      PaperUtility.B10,
      PaperUtility.B11,
      PaperUtility.B12,
    ];
  }

  static get A0(): IPaper {
    return PaperUtility.toPaper("A0", 841, 1189);
  }

  static get A1(): IPaper {
    return PaperUtility.toPaper("A1", 594, 841);
  }

  static get A2(): IPaper {
    return PaperUtility.toPaper("A2", 420, 594);
  }

  static get A3(): IPaper {
    return PaperUtility.toPaper("A3", 297, 420);
  }

  static get A4(): IPaper {
    return PaperUtility.toPaper("A4", 210, 297);
  }

  static get A5(): IPaper {
    return PaperUtility.toPaper("A5", 148, 210);
  }

  static get A6(): IPaper {
    return PaperUtility.toPaper("A6", 105, 148);
  }

  static get A7(): IPaper {
    return PaperUtility.toPaper("A7", 74, 105);
  }

  static get A8(): IPaper {
    return PaperUtility.toPaper("A8", 52, 74);
  }

  static get A9(): IPaper {
    return PaperUtility.toPaper("A9", 37, 52);
  }

  static get A10(): IPaper {
    return PaperUtility.toPaper("A10", 26, 37);
  }

  static get A11(): IPaper {
    return PaperUtility.toPaper("A11", 18, 26);
  }

  static get A12(): IPaper {
    return PaperUtility.toPaper("A12", 13, 18);
  }

  static get B0(): IPaper {
    return PaperUtility.toPaper("B0", 1030, 1456);
  }

  static get B1(): IPaper {
    return PaperUtility.toPaper("B1", 728, 1030);
  }

  static get B2(): IPaper {
    return PaperUtility.toPaper("B2", 515, 728);
  }

  static get B3(): IPaper {
    return PaperUtility.toPaper("B3", 364, 515);
  }

  static get B4(): IPaper {
    return PaperUtility.toPaper("B4", 257, 364);
  }

  static get B5(): IPaper {
    return PaperUtility.toPaper("B5", 182, 257);
  }

  static get B6(): IPaper {
    return PaperUtility.toPaper("B6", 128, 182);
  }

  static get B7(): IPaper {
    return PaperUtility.toPaper("B7", 91, 128);
  }

  static get B8(): IPaper {
    return PaperUtility.toPaper("B8", 64, 91);
  }

  static get B9(): IPaper {
    return PaperUtility.toPaper("B9", 45, 64);
  }

  static get B10(): IPaper {
    return PaperUtility.toPaper("B10", 32, 45);
  }

  static get B11(): IPaper {
    return PaperUtility.toPaper("B11", 23, 32);
  }

  static get B12(): IPaper {
    return PaperUtility.toPaper("B12", 16, 23);
  }
}
